import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { postCart } from 'app/apis/cart';
import { useToast } from '@shared/ui';
import i18n from '@shared/i18n';
import { useCartContext } from 'app/cart/context';
import { MobileBottomSheet } from './MobileBottomSheet';
import { LaptopModal } from './LaptopModal';

export interface RecommendSheetModalReturnRef {
    showRecommend: (productCard: ProductCard) => void;
}

interface RecommendSheetModalPropTypes {}

export const RecommendSheetModal = forwardRef<
    RecommendSheetModalReturnRef,
    RecommendSheetModalPropTypes & { isMobile: boolean }
>((props, ref) => {
    const { isMobile } = props;
    const toast = useToast();
    const [visible, setVisible] = useState(false);
    const [selectedSpec, setSelectedSpec] = useState<ProductSpecDetail | null>(null);
    const [quantity, setQuantity] = useState(1);
    const [productCard, setProductCard] = useState<ProductCard>();

    const {
        actions: { calculate },
    } = useCartContext();

    useImperativeHandle(ref, () => ({
        showRecommend: (item) => {
            setProductCard(item);
            setVisible((prev) => !prev);
        },
    }));

    const handleClose = () => {
        setVisible(false);
        setSelectedSpec(null);
        setQuantity(1);
    };

    const handleAddToCart = async (item: ProductCard) => {
        return calculate(async () => {
            const resp = await postCart({
                product_id: item.id,
                quantity,
                spec_detail_id: selectedSpec?.id,
            });

            if (resp?.data) {
                toast({
                    title: i18n.gettext('已加入購物車'),
                });
                handleClose();
            }
        });
    };

    const handleSelectSpec = (spec: ProductSpecDetail) => {
        setSelectedSpec(spec);
    };

    const handleUpdateQuantity = (value: number) => {
        setQuantity(value);
    };

    const Component = isMobile ? MobileBottomSheet : LaptopModal;

    return (
        <>
            {productCard && (
                <Component
                    productCard={productCard}
                    visible={visible}
                    selectedSpec={selectedSpec}
                    quantity={quantity}
                    onClose={handleClose}
                    onAddToCart={handleAddToCart}
                    onSelectSpec={handleSelectSpec}
                    onUpdateQuantity={handleUpdateQuantity}
                />
            )}
        </>
    );
});

RecommendSheetModal.displayName = 'RecomendSheetModal';
